export const SET_HAPPINESS_TIPS = "SET_HAPPINESS_TIPS";
export const SET_HAPPINESS_TIPS_DELETE = "SET_HAPPINESS_TIPS_DELETE";
